export default "__VITE_ASSET__26e9c8bf__"